import React from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import { agreeWriteOffActItemDirectorAPI } from '../../../../../api/writeOff/writeOffActItemAPI'

const AgreeDirectorForm = ({ writeOffActItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(writeOffActItemBd ? {
        isAgreeDirector: writeOffActItemBd.isAgreeDirector,
        disagreeDirectorText: writeOffActItemBd.disagreeDirectorText
    } : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeWriteOffActItemDirectorAPI({
            id: writeOffActItemBd.id,
            isAgreeDirector: data.isAgreeDirector,
            disagreeDirectorText: data.disagreeDirectorText
        }).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
                // dispatch(editSupplyBillsItemsAllItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження позиції в акті директором
            </p>
        </div>
        {
			formDataProductIsField('agree', 'writeOffActItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'writeOffActItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeDirector', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeDirector', e)}
					forciblyValue={
                        data && data.isAgreeDirector === true ? true :
                        data && data.isAgreeDirector === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'writeOffActItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeDirector === false || data.isAgreeDirector === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'writeOffActItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeDirectorText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeDirectorText', e)}
					forciblyValue={data ? data.disagreeDirectorText : ''}
                    className={data && (data.isAgreeDirector === false || data.isAgreeDirector === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeDirectorForm